import classnames from 'classnames';
import styles from './PageLoading.module.scss';

function PageLoading({ height, className, loading }) {
  return (
    <main className={ classnames(className, styles.container) } style={{ height: `${height}px` }}>
      <div className={ styles.bg } />
      <div className={ styles.wrapper }>
        <div className={ styles.portion } style={{ width: `${loading * 2 * 100}%` }}>
          <img src={ `${process.env.PUBLIC_URL}/images/meta-parade.svg` } className={ styles.logo } alt="META-PARADE" />
        </div>
      </div>
    </main>
  );
}

export default PageLoading;